import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect } from "react";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { requireRules } from "../../helper/method";
import { tokenMock, transportationType } from "../../helper/mock";
import { $api } from "../../helper";
import { useNavigate, useParams, useSearchParams } from "react-router";

export default function AddTransportation() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const params = useParams();
  const navigate = useNavigate();
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/branch/details/",
  );
  const update = $api.useMutation("put", "/site-api/v1/branch/details/");
  const detail = $api.useMutation("get", "/site-api/v1/branch/details-detail/");
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد مسیر حمل و نقل عمومی");
    if (searchParams.get("u_id")) {
      detail.mutate({
        params: {
          query: {
            detail_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
      form.setFieldValue(
        "value",
        detail?.data?.data.value.map((e) => e),
      );
    }
  }, [detail.data]);

  const onFinish = (
    values: {
      title: string;
      value: string[];
      type: 2;
      transport_type: number;
    },
    redirect = true,
  ) => {
    if (!searchParams.get("u_id")) {
      mutate(
        {
          body: {
            ...values,
            branch_u_id: params.id ?? "",
            title: "",
            type: 2,
            transport_type: +values.transport_type,
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate(`/list-transportation/${params.id}`);
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: {
            ...values,
            detail_u_id: searchParams.get("u_id") ?? "",
            title: "",
            type: 2,
            transport_type: +values.transport_type,
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate(`/list-transportation/${params.id}`);
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      initialValues={{
        type: 2,
        title: "",
      }}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به حمل و نقل"
        title="اطلاعات اصلی حمل و نقل"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وسیله نقلیه")}
            name={"transport_type"}
            label="وسیله نقلیه"
            inputProps={{
              placeholder: "لطفا وسیله نقلیه خود را انتخاب کنید.",
              options: transportationType,
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("آدرس ها")}
            name={"value"}
            help="آدرس خود را وارد کنید و Enter بزنید"
            label="آدرس ها"
            inputProps={{
              placeholder: "لطفا آدرس ها خود را وارد کنید.",
              mode: "tags",
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
